<template>
    <div>
        <div class="container" id="container"></div>
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
    name: "map-container",
    data(){
        return{
            aMap:null
        }
    },
    //['AMap.ToolBar','AMap.Scale','AMap.HawkEye','AMap.ControlBar']
    props:{
        plugins:[],
        controlBar:{
            type:Object,
            default:()=>{
                return{
                    position:{
                        top: '10px',
                        right: '10px',
                    }

                }
            }
        },
        toolBar:{
            type:Object,
            default:()=>{
                return{
                    position:{
                        top: '105px',
                        right: '40px',
                    }

                }
            }
        },
        markerConfig:{
            type:Object,
            default:()=>{
                return{
                    position: [114.297511,30.706333],//中心点
                    draggable:true
                }
            }
        },
      mapConfig:{
          type:Object,
          default:()=>{
              return{
                  zoom:16,//缩放等级
                  center: [114.297511,30.706333],//中心点
              }
          }
      }
    },
    mounted() {

    },
    methods:{
        //初始化
        init(){
            this.$nextTick(()=>{
                this.loadMap();
            })
        },
        //加载地图
        loadMap(){
            const that=this;
            AMapLoader.load({
                "key": process.env.VUE_APP_MAP_KEY,              // 申请好的Web端开发者Key，首次调用 load 时必填
                "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                "plugins":[...this.plugins,'AMap.PlaceSearch'] ,           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap)=>{
                this.aMap = new AMap.Map('container',{
                    center:this.mapConfig.center,
                    zoom: this.mapConfig.zoom
                });
                let marker = new AMap.Marker(this.markerConfig)
                marker.on('dragging', (e)=>{
                    // console.log("移动",e)
                    that.$emit('dragend',e)
                });
                this.aMap.add(marker);
                if(this.plugins.includes('AMap.ToolBar')){
                    this.aMap.addControl(new AMap.ToolBar({
                        position: this.toolBar.position
                    }));
                }
                if(this.plugins.includes('AMap.ControlBar')){
                    this.aMap.addControl(new AMap.ControlBar({
                        position:this.controlBar.position
                    }));
                }
                console.log('地图加载完成')
            }).catch(e => {
                console.log(e);
            })
        },
        //销毁地图
        destroyMap(){
            if(this.aMap){
                this.aMap.destroy();
                this.aMap=null;
                console.log("地图已销毁")
            }
        }
    }
}
</script>

<style scoped lang="scss">
    #container {
        width:100%;
        height: 25rem;
    }
</style>
